/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ title: NonNullable<unknown>, time: NonNullable<unknown> }} Station_Work_Event_Speech_SoonInputs */

const vi_station_work_event_speech_soon = /** @type {(inputs: Station_Work_Event_Speech_SoonInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Sắp tới giờ sự kiện: ${i?.title}, bắt đầu lúc ${i?.time}`)
};

/**

* @param {Station_Work_Event_Speech_SoonInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const station_work_event_speech_soon = /** @type {((inputs: Station_Work_Event_Speech_SoonInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Station_Work_Event_Speech_SoonInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_station_work_event_speech_soon(inputs)
});